<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img" v-if="!notFound">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/reset-password.png"
                   alt="login"
                   class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{ isSetup ? 'Nice to meet you!' : 'Reset Password' }}</h4>
                  <p>{{ isSetup ? 'Please set your basic details to get started.' : 'Please enter your new password.' }}</p>
                </div>
                <!-- First/Last Name fields for setup -->
                <div v-if="isSetup" class="mb-6">
                  <vs-input type="text"
                            label-placeholder="First Name"
                            v-model="firstName"
                            class="w-full mb-4"
                            name="firstName"
                            v-validate="'required'"
                            data-vv-validate-on="blur" />
                  <span class="text-danger text-sm">{{ errors.first('firstName') }}</span>
                  
                  <vs-input type="text"
                            label-placeholder="Last Name"
                            v-model="lastName"
                            class="w-full"
                            name="lastName"
                            v-validate="'required'"
                            data-vv-validate-on="blur" />
                  <span class="text-danger text-sm">{{ errors.first('lastName') }}</span>
                </div>
                
                <div>
                  <vs-input type="password"
                            :label-placeholder="$t('Password')"
                            v-model="password"
                            class="w-full"
                            ref="password"
                            name="password"
                            v-validate="'required|min:6|max:50|regex:[^a-zA-Z0-9]'"
                            data-vv-validate-on="blur" />
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                </div>
                <div class="mb-8">
                  <vs-input type="password"
                            :label-placeholder="$t('ConfirmPassword')"
                            v-model="confirm"
                            name="confirm"
                            class="w-full "
                             v-validate="'required|confirmed:password'"
                            data-vv-validate-on="blur"/>

                   <span class="text-danger  text-sm">{{ errors.first('confirm') }}</span>
                </div>

                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                  <vs-button type="border"
                             to="/pages/login"
                             class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Go Back To Login</vs-button>
                  <vs-button class="w-full sm:w-auto" :disabled="!validateForm" @click="confirmNewPassword">{{ isSetup ? 'Complete Setup' : 'Reset' }}</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>

  import AccountsService from "@/accounts/accountsService.js";
  import router from "@/router";
  import { Validator } from 'vee-validate';

  const dictionary = {
    en: {
      messages: {
        regex: () => 'The field must contain at least one non-alphanumerical character',
        confirmed:() => "The passwords do not match"
      }
    },
  };

  Validator.localize(dictionary);

  export default {
    data() {
      return {
        password: "",
        confirm: "",
        firstName: "",
        lastName: "",
        notFound: false,
      };
    },

    computed: {
      isSetup() {
        return this.$route.query.setup === 'true';
      },
      
      validateForm() {
        if (this.isSetup) {
          return !this.errors.any() && this.password != '' && this.confirm != '' && this.firstName != '' && this.lastName != '';
        }
        return !this.errors.any() && this.password != '' && this.confirm != '';
      }
    },
    methods: {
      confirmNewPassword() {
        var instance = this;
        var email = atob(this.$route.query.encoded)
        var payload = {
          User: email,
          Pass: instance.password,
          Token: this.$route.query.token,
          FirstName: instance.isSetup ? instance.firstName : null,
          LastName: instance.isSetup ? instance.lastName : null
        };


        AccountsService.confirmNewPassword(payload).then(function (response) {
          if (response) {
            instance.$vs.notify({
              title: instance.isSetup ? "Setup Complete!" : "Reset password",
              text: instance.isSetup ? "Welcome to TCVelik! You can now log in with your credentials." : "",
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              time: 5000,
            });
            setTimeout(function () { 
              document.location.href = "/pages/login";
            }, 1000);
          }
        }).catch(err => {
          instance.$vs.notify({
            title: 'There was a problem resetting your password.',
            color: "warning",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },
    },
    mounted() {
      var instance = this;

    },
  };
</script>
